import Util from '../lib/util.js';

// declare var $: any;
const $ = window['$'];
let timer;

const arrLang = ['en-US', 'zh-Hans', 'zh-Hant', 'ja-JP', 'vi-VN'];

const CommonFns = {
  /**
   * 获取单据状态高亮样式
   *
   * @param type: string
   * @param status: number      状态
   * @param isPurchase: boolean 类型 true:采购方, false:销售方
   * @param level: number     单据主要状态，默认0，比如采购单，采购状态为主要状态，传1
   */
  getStatusClass(
    type: string,
    status: number,
    isPurchase: boolean = true,
    level: number = 0
  ) {
    if (status === undefined) {
      return;
    }

    // const arrClass = [
    //   'u-inactive',
    //   'u-active',
    //   'u-warning',
    //   'u-danger',
    //   'u-gray',
    //   'u-normal'
    // ];

    const arrClass = ['inactive', 'green', 'orange', 'red', 'gray', 'blue'];

    const StatusCfg = {
      // 打印状态 0 未打印，1 已打印
      B02_Print_Status: [
        [0, 1],
        [0, 1]
      ],
      //索样单-送样状态 0.待送样 1.部分送样
      B2b_Sample_Sending_Status: [
        [0, 2, 1],
        [0, 2, 1]
      ],
      sampleSend: [
        [0, 2, 1],
        [0, 2, 1]
      ],

      //审批状态 0.待送审 1.审批中 2.已审批
      wfStatus: [[0, 2, 1], []],
      //代签收送货单 0.草稿 1.已完成
      bso: [[], [2, 1, 4]],
      // 供应商申诉 0待发布 1待处理 2待审核 3待回复 4已处理
      B2b_appeal_order_status: [
        [0, 2, 2, 5, 1],
        [0, 2, 2, 5, 1]
      ],
      complaint: [
        [0, 2, 2, 5, 1],
        [0, 2, 2, 5, 1]
      ],
      //工装转移
      B02_ToolsTransfer_Status: [
        [0, 2, 5, 5, 1, 5, 1, 0, 0],
        [0, 2, 5, 5, 1, 5, 1, 0, 0]
      ],
      toolingTransfer: [[0, 2, 5, 5, 1, 5, 1, 0, 0]],
      //员工管理列表邀约状态 1.邀约中 2.已加入 3.邀约失败 4.离职
      B02_Invite_Status_Employee: [[0, 2, 1, 3, 0]],
      inviteStatus: [[0, 2, 1, 3, 0]],

      //供应商通知 0.草稿 1.已发送 2.已作废
      Company_Notify_status: [
        [0, 1, 3],
        [0, 1, 3]
      ],
      notify: [
        [0, 1, 3],
        [0, 1, 3]
      ],

      //工装档案状态0:草稿 1:未开始 2:生产中 3:停用 4:失效
      B02_ToolsInfo_Status: [[0, 6, 1, 0, 2]],
      toolingFile: [[0, 6, 1, 0, 2]],

      //收货单状态 0.已冻结 1.有效 2.草稿 3.已确认 4.已撤回
      B02_Ro_Status: [[4, 1, 0, 5, 2]],
      receiveOrder: [[4, 1, 0, 5, 2]],
      //入库单状态 0.已冻结 1.有效 2.草稿 3.已确认 4.已撤回
      B02_Sto_Status: [[4, 1, 0, 5, 2]],

      //供应商登记 0.待审核 1.已通过 2.已拒绝
      B02_Company_Apply_Register_Status: [[2, 1, 3]],
      supplierReg: [[2, 1, 3]],
      registration: [[2, 1, 3]],

      //供应商邀约状态 0.未邀约 1.邀约中 2.已加入 3.邀约失效 4.待审核 5.已退回
      B02_vendor_Invite_Status: [
        [0, 2, 1, 3, 2, 2],
        [0, 2, 1, 3, 2, 2]
      ],
      supplierInvite: [
        [0, 2, 1, 3, 2, 2],
        [0, 2, 1, 3, 2, 2]
      ],

      //电子签章实名认证 0.未认证 1.认证中 2.认证成功
      B02_ESign_Auth_Status: [
        [0, 2, 1],
        [0, 2, 1]
      ],
      eSignAuth: [
        [0, 2, 1],
        [0, 2, 1]
      ],

      // 合同 0过期 1有效 2作废 3待发布 4待确认 5待签署 6已撤回 7签署完成 8待回复 9待审核 10退回
      B02_Contract_Status: [
        [3, 1, 0, 2, 2, 2, 5, 1, 2, 2, 3],
        [3, 1, 0, 2, 2, 2, 5, 1, 2, 2, 3]
      ],
      contract: [
        [3, 1, 0, 2, 2, 2, 5, 1, 2, 2, 3],
        [3, 1, 0, 2, 2, 2, 5, 1, 2, 2, 3]
      ],

      //供应商状态 0无效 1有效 2停用 3黑名单
      B02_Vendor_Status: [[0, 1, 3, 4]],
      vendor: [[0, 1, 3, 4]],

      //授权状态 1 有效 2 失效 3 停用
      authStatus: [[0, 1, 0, 3]],
      //二元状态: 0：否； 1：是
      bool: [
        [0, 1],
        [0, 1]
      ],
      //变更单 0未确认 1已确认 2已结案 3已冻结 4差异待确认 5采购方退回 6待发送 7草稿 8已撤回 9已作废
      B02_co_Status: [
        [0, 1, 1, 0, 2, 3, 2, 0, 2, 0],
        [2, 1, 1, 0, 5, 3, 0, 0, 0, 0]
      ],
      co: [
        [0, 1, 1, 0, 2, 3, 2, 0, 2, 0],
        [2, 1, 1, 0, 5, 3, 0, 0, 0, 0]
      ],
      //退货单: 0已冻结 1有效
      B02_Rto_Status: [
        [0, 1],
        [0, 1]
      ],
      rto: [
        [0, 1],
        [0, 1]
      ],
      //对账单： 0草稿 1待采购方确认 2撤回 3作废 4退回 5已确认 6数量待确认 7待供应方确认
      B02_Reco_Status: [
        [0, 2, 2, 0, 3, 1, 2, 2],
        [0, 2, 2, 0, 2, 1, 2, 2]
      ],
      reco: [
        [0, 2, 2, 0, 3, 1, 2, 2],
        [0, 2, 2, 0, 2, 1, 2, 2]
      ],

      //对账单发票状态：0未开票 1部分开票 2全部开票
      B02_Reco_Invoice_Status: [
        [0, 1, 1],
        [0, 1, 1]
      ],
      recoInvoice: [
        [0, 1, 1],
        [0, 1, 1]
      ],

      //潜在供应商申请状态：0.草稿 1.申请中 2.拒绝 3.已审核 4.已转正式  5 转正中 6 不合格
      B02_Pot_Vendor_Apply_Status: [[0, 2, 3, 1, 5, 2, 3]],
      sourcing: [[0, 2, 3, 1, 5, 2, 3]],

      //潜在供应商资质文件状态：0.未上传 1.部分上传 2.待审核 3.部分审核 4.审核完成
      B02_Vendor_Certificates_Status: [[0, 2, 2, 2, 1]],
      certificates: [[0, 2, 2, 2, 1]],

      //潜在供应商邀约状态：0.未邀约 1.邀约中 2.已加入 3.邀约失效 4.待采购审核 5.采购退回
      //潜在客户邀约状态：  0.未邀约 1.邀约中 2.已加入 3.邀约失效 4.待审核 5.已退回
      B02_Invite_Status: [
        [0, 2, 1, 3, 2, 3],
        [0, 2, 1, 3, 2, 3]
      ],
      potentialInvite: [
        [0, 2, 1, 3, 2, 3],
        [0, 2, 1, 3, 2, 3]
      ],
      //费用单：0.草稿 1.待采购方确认 2.撤回 3.退回 4.已确认 5.作废 6.待供应方确认
      B02_Cost_Status: [
        [0, 2, 2, 3, 1, 4, 2],
        [0, 2, 2, 3, 1, 4, 2]
      ],
      cost: [
        [0, 2, 2, 3, 1, 4, 2],
        [0, 2, 2, 3, 1, 4, 2]
      ],
      //发票通知单： 0:草稿   1:申请中   2:申请撤回  3申请驳回   4已批准申请   5已发布   6发布撤回   7客户退回   8已确认    9作废
      B02_Inv_Status: [
        [0, 2, 2, 2, 2, 2, 2, 2, 1, 0],
        [0, 2, 2, 3, 2, 2, 2, 3, 1, 0]
      ],
      invoice: [
        [0, 2, 2, 2, 2, 2, 2, 2, 1, 0],
        [0, 2, 2, 3, 2, 2, 2, 3, 1, 0]
      ],
      //检验单： 0.检验中 1.待确认 2.退回 3.已确认 4.已作废 5.待发出 6.撤回 7.检测撤回 8 已清理
      B02_Verify_Status: [
        [2, 2, 3, 1, 0, 5, 5, 5, 0],
        [2, 2, 3, 1, 0, 5, 5, 5, 0]
      ],
      iqc: [
        [2, 2, 3, 1, 0, 5, 5, 5, 0],
        [2, 2, 3, 1, 0, 5, 5, 5, 0]
      ],
      //送检状态： 0.未送检 1.部分送检 2.全部送检 3.免检
      B02_Send_Verify_Status: [
        [0, 2, 1, 0],
        [0, 2, 1, 0]
      ],
      sendVerify: [
        [0, 2, 1, 0],
        [0, 2, 1, 0]
      ],
      //预检验单： 0.草稿 1.待审核 2.检验中 3.已完成 4.撤回 5.作废 6.待检验 7.退回
      B02_Pre_Verify_Apply_Status: [
        [0, 2, 2, 1, 0, 0, 2, 3],
        [0, 5, 2, 1, 2, 0, 5, 3]
      ],
      preIqc: [
        [0, 2, 2, 1, 0, 0, 2, 3],
        [0, 5, 2, 1, 2, 0, 5, 3]
      ],
      //检验结果 0.未出结果 1.全部合格 2.部分合格 3.拒收 4.让步接收
      B02_Verify_Result_Flag: [
        [0, 1, 2, 3, 2],
        [0, 1, 2, 3, 2]
      ],
      iqcResult: [
        [0, 1, 2, 3, 2],
        [0, 1, 2, 3, 2]
      ],
      //检验单批次判定 0.合格 1.不合格 3.让步接收 4.部分合格
      batchDetermine: [[1, 3, 0, 2, 2]],

      //延迟送货申请 0.草稿 1.待确认 2.已退回 3.已确认 4.已作废 5.已撤回
      // 交料通知 0.草稿 1.待确认 2.已退回 3.已确认 4.已作废 5.已撤回 6.差异待处理 7.客户退回待答交 8.撤回答交 9.采购撤回
      B02_Acn_Status: [
        [0, 2, 3, 1, 0, 0, 2, 3, 2, 2],
        [0, 2, 2, 1, 0, 0, 2, 3, 2, 2]
      ],
      acn: [
        [0, 2, 3, 1, 0, 0, 2, 3, 2, 2],
        [0, 2, 2, 1, 0, 0, 2, 3, 2, 2]
      ],
      // 订单送货状态 0.待发货 1.部分发货 2.发货完成 3.已结案
      B02_CPo_Delivery_Status: [
        [0, 2, 1, 4],
        [0, 2, 1, 4]
      ],
      dcs: [
        [0, 2, 1, 4],
        [0, 2, 1, 4]
      ],
      // 采购订单：0.草稿 1.待答交，2.答交差异，3.退回，4.变更中，5.已确认，6.已结案，7.已冻结，8.已留置 9.预订单 10.撤回答交 11.采购方撤回 12.作废 13.供应商拒绝 14.待发送
      B02_NPo_Status: [[0, 2, 3, 3, 2, 1, 0, 3, 0, 0, 3, 2, 4, 3, 0], []],
      po: [[0, 2, 3, 3, 2, 1, 0, 3, 0, 0, 3, 2, 4, 3, 0], []],

      // 客户订单：1.待答交，2.差异待确认，3.客户退回，4.变更中，5.已确认，6.已结案，7.已冻结，8.已留置 9.预订单 10.撤回答交 ,11 代答交状态撤回 ,12.作废 13.供应商拒绝
      B02_NCPo_Status: [[], [0, 2, 2, 3, 2, 1, 0, 3, 0, 0, 3, 2, 4, 3]],

      // 销售订单
      B02_So_Status: [[], [0, 2, 2, 3, 2, 1, 0, 3, 0, 0, 3, 2, 4, 3]],
      CPo: [[], [0, 2, 2, 3, 2, 1, 0, 3, 0, 0, 3, 2, 4, 3]],

      //
      B02_Purchase_Order_Mro_Pay_Status: [[0, 2, 1]],
      mroPopay: [[0, 2, 1]],

      //采购订单单身：0.正常 1.结案 2.留置 3.冻结
      B02_Pol_Status: [
        [5, 3, 5, 3],
        [5, 3, 5, 3]
      ],
      poLine: [
        [5, 3, 5, 3],
        [5, 3, 5, 3]
      ],
      //索样单 1：草稿；2：待答交；3：差异待确认；4：已确认；5：答交撤回；6：答交退回；7：采购方撤回；8：作废；8：结案
      B2b_CableSample_Order_Status: [
        [0, 0, 2, 3, 1, 0, 3, 0, 0, 4],
        [0, 0, 2, 3, 1, 0, 3, 0, 0, 4]
      ],
      sampleO: [
        [0, 0, 2, 3, 1, 0, 3, 0, 0, 4],
        [0, 0, 2, 3, 1, 0, 3, 0, 0, 4]
      ],
      //采购排程：0.草稿，1.待答交，2.部分答交，3.差异待确认，4.全部答交，5.已失效
      //客户排程：0.草稿，1.待答交，2.答交已保存，3.差异待确认，4.答交无差异，5.差异已确认，6.退回，7.部分答交有差异，8.部分答交无差异，9.已失效
      B02_Sch_Batch_Status: [
        [0, 2, 1, 3, 1, 4],
        [0, 2, 2, 2, 1, 1, 3, 2, 1, 4]
      ],
      // 客户排程
      B02_Sch_Order_Status: [
        [0, 2, 1, 3, 1, 4],
        [0, 2, 2, 2, 1, 1, 3, 2, 1, 4]
      ],
      sch: [
        [0, 2, 1, 3, 1, 4],
        [0, 2, 2, 2, 1, 1, 3, 2, 1, 4]
      ],
      //排程调整类型
      schOldBatchType: [
        [0, 2, 2, 1],
        [0, 2, 2, 1]
      ],
      //生产计划排程：0.草稿，1.已发布，2.已失效
      fcst: [
        [0, 1, 4],
        [0, 1, 4]
      ],
      //物料询价招标：0.草稿, 1.未开始, 2.报价中, 3.已取消, 4.比价中, 5.已完成, 6.已结束, 7.比价结束 8.待比价 9.已转二次报价 10.部分二次报价 11.作废
      B02_Inquiry_Status: [
        [0, 0, 5, 0, 2, 1, 0, 0, 2, 0, 5, 0, 5, 5, 5],
        [0, 0, 2, 0, 5, 1, 0, 0, 5, 0, 5, 0, 2, 2, 2]
      ],
      inquiry: [
        [0, 0, 5, 0, 2, 1, 0, 0, 2, 0, 5, 0, 5, 5, 5],
        [0, 0, 2, 0, 5, 1, 0, 0, 5, 0, 5, 0, 2, 2, 2]
      ],
      //内部询价单：0.草稿，1.已发布，2.已取消, 3.已退回，4.已完成，5.已回复 6.作废， 7.已结案, 8.已撤回， 9.已退回需求
      B02_Inner_Inquiry_Status: [[0, 2, 4, 3, 1, 1, 4, 0, 0, 3]],
      innerInquiry: [[0, 2, 4, 3, 1, 1, 4, 0, 0, 3]],

      //询价报价单：0.草稿，1.已发布，2.发布退回, 3.未入选，4.部分入选，5.全部入选 6.已作废
      B02_Quote_Status: [[0, 2, 3, 3, 1, 1, 4]],
      inquiryQuota: [[0, 2, 3, 3, 1, 1, 4]],

      //内部询价单处理状态: 1.待询价，2.待回复，3.已确认
      B02_Inquiry_Operate_Status: [[0, 2, 1, 2]],
      innerInquiryOperate: [[0, 2, 1, 2]],

      //采购付款计划：0.草稿，1.待审核，2.已审核，3.已撤回，4.已退回，5.已作废 6.未到期 7.待申请
      //供应商付款计划：0.草稿，1.待审核，2.已审核，3.已撤回，4.已退回，5.已作废 6.未到期 7.待申请
      pmp: [[0, 2, 1, 3, 3, 0, 5, 2, 2]],
      vPmp: [[0, 2, 1, 3, 3, 0, 5, 2, 2]],
      //预付款单 0:草稿; 1:待审核; 2:已审核; 3:已撤回; 4:已退回; 5:已作废
      B02_PrepayOrder_status: [
        [0, 2, 1, 2, 3, 4],
        [0, 2, 1, 2, 3, 4]
      ],
      ppm: [[0, 2, 1, 2, 3, 4]],

      //付款申请  0:草稿; 1:待审核; 2:已审核; 3:已撤回; 4:已退回; 5:已作废
      B02_Pay_Apply_status: [
        [0, 2, 1, 2, 3, 4],
        [0, 2, 1, 2, 3, 4]
      ],
      pma: [
        [0, 2, 1, 2, 3, 4],
        [0, 2, 1, 2, 3, 4]
      ],

      //'提前付款申请 0:草稿; 1:待预审(供应商发布后); 2:待传协议(采购方填写回扣率后); 3:待审核(供应商上传协议附件后); 4：已撤回 5:已确认; 6:已退回'; 7: 已退回协议; 8.已作废
      B02_Before_Pay_Apply_status: [
        [0, 2, 2, 2, 2, 1, 3, 3, 4],
        [0, 2, 2, 2, 2, 1, 3, 3, 4]
      ],
      epma: [
        [0, 2, 2, 2, 2, 1, 3, 3, 4],
        [0, 2, 2, 2, 2, 1, 3, 3, 4]
      ],

      //付款单：0.草稿；1.待审核；2.已审核；3.已撤回；4.已退回；5；已作废
      //客户付款通知
      B02_ReceiptOrder_Status: [
        [0, 2, 1, 2, 2, 4],
        [0, 2, 1, 2, 2, 4]
      ],
      rcp: [
        [0, 2, 1, 2, 2, 4],
        [0, 2, 1, 2, 2, 4]
      ],
      //商机线索管理 单据状态 0:待发布; 1:已完成; 2:待物料清单; 3:待转询价; 4:退回物料清单
      B02_Opportunity_Status: [
        [0, 1, 2, 5, 3],
        [0, 1, 2, 5, 3]
      ],
      oppOrder: [[0, 1, 2, 5, 3]],

      //商机线索管理 询价状态；0:部分；1:完成
      B_Inq_status: [[2, 1]],
      oppInq: [[2, 1]],

      // 送货通知：0.未发送 1.待签收 2.签收中 3.已完成 4.撤回 5.申请中 6.退回 7.已同意 8.作废 9.部分同意 10.已冻结 11.申请撤回 12.已清理 13.申请退回
      B02_Dn_Status: [
        [0, 2, 2, 1, 0, 2, 3, 5, 4, 5, 0, 2, 0, 2],
        [0, 2, 2, 1, 0, 2, 3, 5, 4, 5, 0, 2, 0, 2]
      ],

      // 送样通知：0.未发送 1.待签收 2.签收中 3.已完成 4.撤回 6.退回 8.作废 10.已冻结 12.采购撤回
      B02_Sample_Dn_Status: [
        [0, 2, 2, 1, 0, 2, 3, 5, 4, 5, 0, 0, 2],
        [0, 2, 2, 1, 0, 2, 3, 5, 4, 5, 0, 0, 2]
      ],

      // 代收单状态，同送货通知
      B02_Dn_Sign_For_Status: [
        [0, 2, 2, 1, 0, 2, 3, 5, 4, 5, 0, 0],
        [0, 2, 2, 1, 0, 2, 3, 5, 4, 5, 0, 0]
      ],
      deliverNotify: [
        [0, 2, 2, 1, 0, 2, 3, 5, 4, 5, 0, 0],
        [0, 2, 2, 1, 0, 2, 3, 5, 4, 5, 0, 0]
      ],

      //0.待发货 1.部分发货 2.发货完成 3.已结案
      CPoDn: [[], [2, 1, 1, 0]],
      // 竞价：0:草稿；1:未开始；2:竞价中；3:已取消；4:比价中；5:已完成 6.待比价 7.部分二次竞价 8.已完成竞价 9.已结束 10.延长中 11.取消中 12.作废
      B02_Bid_Status: [
        [0, 0, 5, 0, 2, 1, 2, 5, 1, 0, 5, 5, 3],
        [0, 0, 5, 0, 2, 1, 2, 5, 1, 0, 2, 2, 3]
      ],
      bid: [
        [0, 0, 5, 0, 2, 1, 2, 5, 1, 0, 5, 5, 3],
        [0, 0, 5, 0, 2, 1, 2, 5, 1, 0, 2, 2, 3]
      ],
      //订单直送看板 0草稿  1待送货  2作废  3部分送货  4全部送货 5待答交 6答交差异 7客户退回 8撤回 9结案
      B02_Direct_Status: [
        [0, 2, 4, 2, 1, 5, 3, 3, 3, 5],
        [0, 2, 4, 2, 1, 2, 3, 3, 3, 5]
      ],
      tpp: [
        [0, 2, 4, 2, 1, 5, 3, 3, 3, 5],
        [0, 2, 4, 2, 1, 2, 3, 3, 3, 5]
      ],
      // 请购单 0草稿  1待转采购  2部分采购  3全部采购  4冻结 5结案 6 部分询价 7已转询价 8已撤回 9已作废 10待转询价 11已转竞价 12已取消
      B02_Requisition_Order_Status: [
        [0, 3, 2, 1, 4, 5, 2, 1, 0, 0, 3, 1, 4],
        []
      ],
      requisition: [[0, 3, 2, 1, 4, 5, 2, 1, 0, 0, 3, 1, 4], []],

      //收货状态 0待收货 1部分收货 2收货完成 3已结案
      B02_Po_Receive_Status: [
        [2, 1, 1, 0],
        [2, 1, 1, 0]
      ],
      receive: [
        [2, 1, 1, 0],
        [2, 1, 1, 0]
      ],

      //差异同步状态 0未同步 1同步中 2成功 3失败 4撤回中
      B02_Po_Diff_Sync_Status: [
        [0, 2, 1, 3, 2],
        [0, 2, 1, 3, 2]
      ],
      syncDiff: [
        [0, 2, 1, 3, 2],
        [0, 2, 1, 3, 2]
      ],

      //同步状态 0未同步 1同步中 2成功 3失败
      sync: [
        [0, 2, 1, 3],
        [0, 2, 1, 3]
      ],
      // 同步状态 0.未同步 1.同步中 2.同步成功 3.同步失败 4.撤回中 5.撤回成功 6.撤回失败
      B02_Order_Sync_Status: [
        [0, 2, 1, 3, 2, 2, 3],
        [0, 2, 1, 3, 2, 2, 3]
      ],

      //问卷调查 0.未发布 1.已发布
      questionPub: [
        [0, 1],
        [0, 1]
      ],

      //问卷调查 0.未答复 1.已答复
      B02_Question_Ack_Status: [
        [0, 1],
        [2, 1]
      ],
      questionAck: [
        [0, 1],
        [2, 1]
      ],

      //问卷调查 0.有效 1.已作废
      B02_Question_Val_Status: [
        [1, 0],
        [1, 0]
      ],
      questionVal: [
        [1, 0],
        [1, 0]
      ],

      // 采购验收状态 0-待发布、1-待确认、2-已确认、3-已撤回、4-已作废
      B02_Po_Assets_Acceptance_Status: [[0, 2, 1, 2, 4]],
      paas: [[0, 2, 1, 2, 4]],
      // 核价单 0.待发布 1.待审核 2.已完成 3.已作废 4.已撤回
      B02_Price_Order_Status: [[0, 2, 1, 4, 0]],
      pricing: [[0, 2, 1, 4, 0]],

      //核价失效单 0.待发布 1.已发布 2.已作废
      B02_Pricing_invalid_Status: [[0, 1, 3]],
      pricingInvaild: [[0, 1, 3]],

      //8D报告单 0.待发出 1.待改善 2.待结案 3.已结案 4.待审核 5.已撤回 6.作废
      B02_Product8D_Report_Status: [
        [0, 2, 5, 1, 2, 2, 4],
        [0, 2, 5, 1, 2, 2, 4]
      ],
      d8Report: [[0, 2, 5, 1, 2, 2, 4]],
      //重要度 0.低 1.中 2.高
      Important: [[0, 1, 2, 3]],
      // 供应商准入/物料报告 0.待发布 1.待回复 2.带评审 3.退回 4.待审核 5.已完成 6.作废
      B02_Material_Report_Status: [
        [0, 2, 2, 3, 2, 1, 0],
        [0, 2, 2, 3, 2, 1, 0]
      ],
      ItemReport: [
        [0, 2, 2, 3, 2, 1, 0],
        [0, 2, 2, 3, 2, 1, 0]
      ],
      //供应商准入报告0.待发布 1.待回复 2.带评审 3.退回 4.待审核 5.已完成 6.作废
      SupplierReport: [
        [0, 2, 2, 3, 2, 1, 0],
        [0, 2, 2, 3, 2, 1, 0]
      ],

      //物料准入报告结果 1.合格 2.有条件使用 3.不合格
      B02_Material_Report_Result: [
        [0, 1, 5, 3],
        [0, 1, 5, 3]
      ],
      reportResult: [
        [0, 1, 5, 3],
        [0, 1, 5, 3]
      ],

      // ECN报告
      B02_Ecn_Report_Status: [
        [0, 2, 5, 2, 1, 1, 3, 3, 1, 2],
        [0, 2, 5, 2, 1, 1, 3, 3, 1, 2]
      ],
      ECN: [
        [0, 2, 5, 2, 1, 1, 3, 3, 1, 2],
        [0, 2, 5, 2, 1, 1, 3, 3, 1, 2]
      ],
      // 投标单状态
      evaluateModule: [[0, 2, 3, 4]],
      //项目招标状态 0.项目立项 1.待预审 2.待投标 3.待评标 4.评标结束 5.已完成 6.已结束 7.已取消 8.部分投标 9.全部投标,10二次招标, 11评标中 12.作废 13.待发布 14.延长中 15.结束中 16.取消中
      B02_Project_Bidding_Status: [
        [0, 2, 2, 2, 1, 1, 1, 4, 2, 1, 0, 2, 3, 2, 5, 5, 5],
        [0, 2, 2, 2, 1, 1, 1, 4, 2, 1, 0, 2, 3, 2, 5, 5, 5]
      ],
      projectIfb: [[0, 2, 2, 2, 1, 1, 1, 4, 2, 1, 0, 2, 3, 2, 5, 5, 5]],

      // 项目报价状态
      B02_Project_Quote_Status: [[5, 4, 2, 5, 3, 2, 1, 1, 4, 5, 5, 3]],
      projectIfbQuos: [[5, 4, 2, 5, 3, 2, 1, 1, 4, 5, 5, 3]],

      //项目预询状态 0.草稿 1.待回复 2.评审中 3.已完成 4.已转招标 5.已作废
      B02_Prepare_Project_Status: [
        [0, 2, 2, 1, 1, 0, 1, 2, 1],
        [0, 2, 2, 1, 1, 0, 1, 2, 1]
      ],
      projectPreInq: [[0, 2, 2, 1, 1, 0, 1, 2, 1]],

      // 项目预询报价状态
      B02_Prepare_Project_Quote_Status: [[0, 1, 3, 1, 2, 3]],
      projectPreQuos: [[0, 1, 3, 1, 2, 3]],

      // 内部商城引入单 0草稿(待发布),1选品中(准备发布),2，待发布3已完成(发布),4已撤回,5已作废
      B02_Introduce_Status: [[0, 2, 5, 1, 3, 4]],
      introduce: [[0, 2, 5, 1, 3, 4]],
      //违约/索赔通知单   0:草稿；1:待确认；2:撤回；3:被退回；4:已确认; 5:作废
      B02_punish_Status: [
        [0, 2, 2, 3, 1, 0],
        [0, 2, 2, 3, 1, 0]
      ],
      penalty: [[0, 2, 2, 3, 1, 0]],
      //供应商清退 0: 待发布 1:待审批 2:已撤回 3:已确定 4.作废
      B02_eliminate_vendor_notice_Status: [[0, 2, 2, 1, 3]],
      terminate: [[0, 2, 2, 1, 3]],
      // 0:未审批；1:已审批；2:忽略审批（同一关只用其中一人审批&已被其他人审批）
      approval: [[2, 1, 0]],
      //供应商信息变更   0:草稿；1:待确认；2:退回；3:撤回；4:作废; 5:已确认
      B02_Company_Changed_Status: [
        [0, 2, 3, 2, 0, 1],
        [0, 2, 3, 2, 0, 1]
      ],
      companyChange: [
        [0, 2, 3, 2, 0, 1],
        [0, 2, 3, 2, 0, 1]
      ],
      // 样品处理状态   0:待签收；1:待检验；2:待试产；3:待判定；4:已完成; 5:退回
      B02_Sample_Status: [
        [2, 5, 5, 5, 1, 3],
        [2, 5, 5, 5, 1, 3]
      ],
      sample: [
        [2, 5, 5, 5, 1, 3],
        [2, 5, 5, 5, 1, 3]
      ],
      // 供应商资源池状态   0:草稿；1:审批中；2:审批未通过；3:发布；4:作废
      B02_Res_Pool_Status: [[0, 5, 2, 1, 0]],
      resource: [[0, 5, 2, 1, 0]],
      // 质量目标管理状态   0:待发布；1:待确认；2:已确认
      B02_Quality_Track_Status: [
        [0, 5, 2],
        [0, 5, 2]
      ],
      quality: [
        [0, 5, 2],
        [0, 5, 2]
      ],
      // 资质状态   0:草稿；1:待回复；2:待确认 3:退回待回复 4:已完成 5:作废 6:撤回
      B02_Certificates_Status: [
        [0, 2, 2, 3, 1, 0, 3],
        [0, 2, 2, 3, 1, 0, 3]
      ],
      certificate: [
        [0, 2, 2, 3, 1, 0, 3],
        [0, 2, 2, 3, 1, 0, 3]
      ],
      // 签章状态   0:未签章；1:签章中；2:完成；3:撤销；4:过期；5:拒签；6:忽略；7:失败；8:作废
      esignStatus: [
        [0, 2, 1, 0, 3, 3, 0, 3, 0],
        [0, 2, 1, 0, 3, 3, 0, 3, 0]
      ],
      //优先检验 0.正常，1.优先，2.紧急
      firstCheck: [[0, 2, 3]],
      //优先检验 0:待发布 1:待确认 2:部分确认 3:已确认
      // 图纸变更 0:待发布,1:待确认,2:部分确认,3:已确认,4:撤回,5:作废
      B2b_prod_graph_change_status: [
        [0, 5, 1, 1, 2, 0],
        [0, 5, 1, 1, 2, 0]
      ],
      // 供应商改善报告 0:待发布,1:待回复,2:已撤回,3:待审核,4:已退回,5:不合格,6:结案
      B2b_improve_report_status: [
        [0, 2, 2, 2, 3, 3, 3],
        [0, 2, 2, 2, 3, 3, 3]
      ],
      improve: [[0, 2, 2, 2, 3, 3, 3]],
      //报价模板状态 0草稿 1启用 2停用 3作废
      quoteTmp: [[0, 1, 3, 4]],
      //供应商绩效通知 0.待回复 1.已确认
      B2b_Assessment_Score_Notice: [
        [0, 1],
        [2, 1]
      ],
      // 售后服务单 状态 0 待发布 1 售后中 2已完成 3已关闭
      B02_After_Sale_Status: [[0, 5, 1, 3]],
      //关务资料管理 0.未完成 1.采购审核 2.已完成 3.退回 4.已撤回 5.待回复 6.关务审核
      B2b_Prod_customs_status: [
        [0, 2, 1, 3, 0, 2, 2],
        [0, 2, 1, 3, 0, 2, 2]
      ],
      //物料停产 0.草稿 1.待审核 2.已审核 3.已撤回 4.退回 5.结案
      B02_Stop_Product_Report_Status: [
        [0, 2, 1, 0, 3, 3],
        [0, 2, 1, 0, 3, 3]
      ],
      //备案状态 0:已备案 1:未备案 2:备案中
      B02_filing_status: [
        [1, 0, 2],
        [1, 0, 2]
      ],
      //物料关务备案 0:未备案 1:已备案
      B02_Customs_Record_Status: [
        [0, 1],
        [0, 1]
      ],
      //品类单状态 0:草稿 1:已完成
      B02_prod_category_manage_status: [[0, 1]]
    };

    let index = isPurchase ? 0 : 1;
    let cfg;
    // let cfg = StatusCfg[type] ? StatusCfg[type][index] : [1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1];
    if (StatusCfg[type]) {
      cfg = StatusCfg[type][index];
    }
    if (Util.isEmpty(cfg)) {
      return '';
    }
    if (level === 1) {
      return 'level1 ' + arrClass[cfg[status]];
    }
    return arrClass[cfg[status]];
  },

  /**
   * 获取单据按钮权限
   *
   * @param type: string        单据类型
   * @param code: number        按钮编码
   * @param user: any           user对象
   * @param detail: any         单据详情
   * @param isPurchase: boolean 类型 true:采购方, false:销售方
   *
   * @returns boolean
   */
  getButtonAuth(
    type: string,
    code: string,
    user: any,
    detail: any,
    isPurchase: boolean = true
  ) {
    if (Util.isEmpty(user) || Util.isEmpty(detail)) {
      return false;
    }
    switch (type) {
      case 'delivery': //送货通知
        //multiRelationRoleType 1.收货方 2.账款方。
        switch (code) {
          case 'GOODS_ARRIVED': //货物送达。多角送货单仅收货企业显示
            return isPurchase
              ? user.checkAuth('10030106') &&
                  [1, 2].includes(detail.status) &&
                  detail.logisticsStatus !== 2 &&
                  detail.multiRelationRoleType !== 2
              : false;
          case 'CONFIRM_PUBLISH': //确认发出。多角送货单仅账款企业显示
            return isPurchase
              ? user.checkAuth('10030102') &&
                  [1, 2].includes(detail.status) &&
                  detail.multiRelationRoleType !== 1
              : false;
          case 'NEW_IQC_SHEET': //新建来料检验。多角送货单仅收货企业显示
            return isPurchase
              ? user.checkAuth('10080102') &&
                  detail.deliveryType !== 2 &&
                  [1, 2, 3].includes(detail.status) &&
                  detail.multiRelationRoleType !== 2
              : false;
          case 'RECALL': //撤回签收结果。多角送货单仅账款企业显示
            return isPurchase
              ? user.checkAuth('10030102') &&
                  [3].includes(detail.status) &&
                  detail.multiRelationRoleType !== 1
              : false;
          case 'NEW_RECEIPT': //转收货 多角送货单不显示
            return isPurchase
              ? user.checkAuth('10030203') &&
                  detail.deliveryType !== 2 &&
                  detail.convertStatus !== 2 &&
                  [1, 2].includes(detail.status) &&
                  ![1, 2].includes(detail.multiRelationRoleType)
              : false;
          case 'NEW_STORAGE_IN': //转入库 多角送货单不显示
            return isPurchase
              ? user.checkAuth('10030203') &&
                  detail.deliveryType !== 2 &&
                  detail.convertStatus !== 2 &&
                  [1, 2].includes(detail.status) &&
                  ![1, 2].includes(detail.multiRelationRoleType)
              : false;
        }
        break;
      default:
        return false;
    }
  },

  //格式化文本
  formatText(str) {
    let res = str;
    if (res) {
      res = res.replace(/\t/g, '&nbsp;&nbsp;&nbsp;&nbsp;');
      res = res.replace(/\r\n/g, '<br/>');
      res = res.replace(/\\r\\n/g, '<br/>');
      res = res.replace(/\n/g, '<br/>');
      res = res.replace(/\s/g, '&nbsp;');
    }
    return res;
  },

  /**
   * 生成订单扩展字段信息（采购说明）
   *
   * @param item: any  订单单身
   */

  //生成单身扩展字段
  genExtendFields(item: any, prop?) {
    if (!item) {
      return;
    }
    let extendFields: any[] = [];
    let extendFieldsStr = '';
    let child = prop ? item[prop] : item;
    let fieldsShow = child ? child.fieldsShow : undefined;
    if (!Util.isEmpty(fieldsShow)) {
      let obj = Util.jsonDecode(fieldsShow);
      for (let key in obj) {
        //仅加入有值的扩展字段
        if (child[key] !== null) {
          if (child[key]?.includes('\\r\\n')) {
            //带有换行回车符的，拆成多行显示
            let subs = child[key].split('\\r\\n');
            subs.forEach((sub, i) => {
              extendFields.push({
                key: i === 0 ? obj[key] : '',
                value: sub,
                prop: key
              });
              extendFieldsStr += obj[key] + ':' + sub + '；';
            });
          } else {
            extendFields.push({
              key: obj[key],
              value: child[key],
              prop: key
            });
            extendFieldsStr += obj[key] + ':' + child[key] + '；';
          }
        }
      }
    }
    item.extendFields = extendFields;
    item.printExtendFields = extendFields; //打印用
    item.extendFieldsStr = extendFieldsStr; //不换行
  },

  //处理单头采购说明（适用于送货单单头采购说明格式）
  //格式示例："{\"code\":\"extendN05\",\"name\":\"产品线/JIT标识/图纸版本\",\"value\":\"345/JIT/V01\"}"
  extendJson2Obj(detail: any = {}, prop: string = 'extendJson') {
    if (!detail) {
      return;
    }
    let obj: any = {};
    let extendFields: any[] = [];
    let extendJson = detail[prop];
    if (!Util.isEmpty(extendJson)) {
      obj = Util.jsonDecode(extendJson);
      extendFields[0] = {
        key: obj.name,
        value: obj.value,
        prop: obj.code
      };
      detail.extendJsonShow = obj.name + ':' + obj.value; //打印用
    }
    return obj;
  },

  //格式化送货单号
  formatBillNo(id: string) {
    if (!id) {
      return '';
    }
    //新送货单号
    if (id.length === 12) {
      let arr = id.split('');
      arr = arr.map((item, i) => (i === 1 || i === 7 ? item + ' ' : item));
      return arr.join('');
    }
    return id.replace(/[\s]/g, '').replace(/(\d{4})(?=\d)/g, '$1 ');
  },

  /**
   * 数量变化(keyup)
   *
   * @param value
   * @param allowMinus 是否允许负数
   *
   * @returns
   */
  qtyChange(value, allowMinus: boolean = true) {
    if (/^-?\d*(\.\d*)?$/.test(value) === false || value === '.') {
      //允许 '', '5.' 以方便用户输入
      value = 0;
    }
    if (!allowMinus && !isNaN(value) && Number(value) < 0) {
      value = 0;
    }
    return value;
  },

  /**
   * 数量字段失去焦点(change)
   *
   * @param value
   * @param allowMinus 是否允许负数
   *
   * @returns
   */
  qtyBlur(value, allowMinus: boolean = true) {
    if (typeof value === 'number') {
      return value;
    }
    if (/^-?\d+\.?$/.test(value) === true) {
      value = value.replace('.', '');
    }
    if (value === '' || value === undefined) {
      value = 0;
    }
    if (!allowMinus && !isNaN(value) && Number(value) < 0) {
      value = 0;
    }
    return value;
  },

  //物料特征值处理
  getFeatureValue(compProdFeatureList) {
    let compProdFeatureStr = '';
    if (Array.isArray(compProdFeatureList)) {
      compProdFeatureStr = compProdFeatureList
        .filter((row, i) => i < 2 && row.specShow === 1)
        .map(row => row.featureName)
        .join();
    }
    return compProdFeatureStr;
  }
};

export default CommonFns;
